module.exports = __webpack_public_path__ + "static/media/dial-pad.b57374ee.svg";